import React from 'react';  
import {PAGING_END_INDEX} from '../../../configs/staticConfigs';

class Paginator extends React.Component { 
    
    render(){
        const {
            activePage,totalPage,startIndex,endIndex            
        } = this.props

        const pageNumbers = [];
        for (let i = 1; i <= totalPage; i++) {
          pageNumbers.push(i);
        }  

        let previous = '<<';
        let next = '>>';

        return(
            <div className="rsdt rsdt-paginate">
                <button hidden={pageNumbers.length===0 || totalPage<=1} disabled={(activePage === 1)||(endIndex-PAGING_END_INDEX<=1)} className="rsdt rsdt-paginate button" type="button" onClick={e => this.props.onPagePrevious(e)}>{previous}</button>
                {pageNumbers.slice(startIndex, endIndex).map(number => {  
                    return (
                        <button hidden={pageNumbers.length===0 || totalPage<=1} key={number} id={number} className={activePage === number ? 'rsdt rsdt-paginate button active' : 'rsdt rsdt-paginate button'} type="button" onClick={e => this.props.onPageUp(e)}>{number}</button>
                    )
                })                  
                }        
                <button hidden={pageNumbers.length===0 || totalPage<=1} disabled={(activePage === totalPage) || (startIndex+PAGING_END_INDEX>=totalPage)} className="rsdt rsdt-paginate button" type="button" onClick={e => this.props.onPageNext(e)}>{next}</button>
            </div>
        )
    }
}
export default Paginator; 